import { Auth } from 'aws-amplify';

export const handleAutoLogin = async (email, job_title, company, phone, name) => {
  try {
    // Check if email parameter is present
    if (!email) {
      return { success: false, message: 'No email parameter found' };
    }

    // Check if we're on the ESID-25-013 project path
    const currentPath = window.location.pathname;
    if (!currentPath.includes('esid-25-013') && !currentPath.includes('signin')) {
      return { success: false, message: 'Automatic login only available for ESID-25-013 project' };
    }

    // Use the specified credentials for automatic login
    const username = 'leadgen@entras.be';
    const password = 'Leadgen@entr8s.be';
    
    // Attempt to sign in with the specified credentials
    const user = await Auth.signIn(username, password);
    
    // Get user info and projects (similar to handleSignIn)
    try {
      const userInfoResponse = await fetch('/get-user-info', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${user.signInUserSession.accessToken.jwtToken}`,
        },
      });

      if (userInfoResponse.ok) {
        const userData = await userInfoResponse.json();

        if (userData?.projects) {
          // Get project names
          const projectNames = userData.projects.map(project => project.name) || [];
          localStorage.setItem('allowedProjects', JSON.stringify(projectNames));

          if (projectNames.length > 0) {
            // Get user roles
            const all_roles_keys = userData.projects.map(project => Object.keys(project.roles));
            const all_roles_keys_flat = all_roles_keys.flat();
            const all_roles_keys_flat_lower = all_roles_keys_flat.map(role => role.toLowerCase());
            
            // Get project pages
            const getProjectPages = (response, projectName) => {
              const project = response?.projects.find(proj => proj.name === projectName);
              if (!project) return [];
              const pages = Object.values(project.roles)
                .flatMap(role => role.pages);
              return [...new Set(pages)];
            };

            if (projectNames.length === 1) {
              const projectName = projectNames[0];
              let allowedPages = getProjectPages(userData, projectName);

              localStorage.setItem('selectedProject', projectName);
              localStorage.setItem('allowedProjects', JSON.stringify(projectNames));
              localStorage.setItem('all_roles', JSON.stringify(all_roles_keys_flat_lower));
              localStorage.setItem('allowedPages', JSON.stringify(allowedPages));
            } else {
              // Multiple projects - store basic info, navigation will be handled by caller
              localStorage.setItem('selectedProject', projectNames[0]); // Default to first project
              localStorage.setItem('allowedProjects', JSON.stringify(projectNames));
              localStorage.setItem('all_roles', JSON.stringify(all_roles_keys_flat_lower));
            }
          }
        }
      } else {
        console.warn('Failed to fetch user info:', await userInfoResponse.text());
      }
    } catch (userInfoError) {
      console.warn('Error fetching user info:', userInfoError);
    }
    
    return { 
      success: true, 
      user,
      message: 'Automatic login successful'
    };
  } catch (error) {
    console.error('Automatic login failed:', error);
    return { 
      success: false, 
      error,
      message: error.message || 'Automatic login failed'
    };
  }
};

export const checkForEmailParameter = () => {
  const urlParams = new URLSearchParams(window.location.search);
  //http://localhost:3000/signin-leadgen?email=ali222.cesur%40entras.be&job_title=Engineer&company=Entras&phone=454878178&name=Stijn%20Bernaer
  const email = urlParams.get('email');
  const job_title = urlParams.get('job_title');
  const company = urlParams.get('company');
  const phone = urlParams.get('phone');
  const name = urlParams.get('name');
  return { email, job_title, company, phone, name };
};

export const getReturnUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('returnUrl') || '/esid-25-013/dashboard';
}; 